export enum HrefLangActions {
  Add = 'ADD_HREF_LANG',
}

export interface HrefLangType {
  hreflang: string;
  href: string;
}

export type HrefLangPayloadType = {
  [HrefLangActions.Add]: HrefLangType[];
};
